
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { ChildComponentMixin } from '@/mixins'
import { mixins } from 'vue-class-component'
import { VueEditor } from 'vue2-editor'

@Component({
    components: {
        VueEditor,
    },
})

export default class AppInputQuill extends mixins(ChildComponentMixin) {
    @Prop({ default: 0 }) private length!: number
    @Prop({ default: '' }) private placeholder!: string
    @Prop({ default: '<p><br></p>' }) private value!: string

    private textLength: number = 0

    get editorOptions() {
        return {
            modules: {
                toolbar: {
                    container: [
                        [ { font: [] }, { header: [] }],
                        ['bold', 'italic', 'underline', 'strike'],
                        [{ align : '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                        ['blockquote'],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        [{ indent: '-1' }, { indent: '+1' }],
                        [{ color: [] }, { background: [] }],
                        ['link', 'image', 'video'],
                        ['clean'],
                    ],
                    handlers: {
                        image: this.imageURLHandler,
                    },
                },
            },
        }
    }

    get hasExceededLength() {
        return this.textLength > this.length
    }

    get getQuillObject() {
        return this.$children[0].$data.quill
    }

    public imageURLHandler() {
        const quill = this.getQuillObject
        const range = quill.getSelection().index
        const imageURL = window.prompt('Insira a URL da imagem')

        if (imageURL) {
            quill.insertEmbed(range, 'image', imageURL)
        }
    }

    @Emit('input')
    public onInput(value: string) {
        const quill = this.getQuillObject

        this.textLength = quill.getText().length - 1

        return value
    }
}
